import axios from 'axios';
import FileSaver from 'file-saver';
import moment from 'moment';

import { DeepCopy } from '../../tables/shared/TableEventHelpers';

const CancelToken = axios.CancelToken;
let cancel;

export async function GetWindow(apiUrl, requestObject, callback) {
    const uri = `api/${apiUrl}/dataWindow`;

    let fixedRequestObject = DeepCopy(requestObject);
    for (var filterName in fixedRequestObject.filters) {
        fixedRequestObject.filters[filterName] = JSON.stringify(fixedRequestObject.filters[filterName]);
    }

    try {
        axios
            .post(uri, fixedRequestObject, {
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false, data: null });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false, data: null });
    }
}

export async function GetExcel(apiUrl, requestObject, excelName, callback) {
    const url = `api/${apiUrl}/excel/`;

    let fixedRequestObject = DeepCopy(requestObject);

    if (apiUrl !== 'crmDealFront') {
        for (var filterName in fixedRequestObject.filters) {
            fixedRequestObject.filters[filterName] = JSON.stringify(fixedRequestObject.filters[filterName]);
        }
    }

    try {
        axios
            .post(url, fixedRequestObject, {
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                responseType: 'blob',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                callback();
                FileSaver.saveAs(response.data, `Alltid_${excelName}_${moment().format('DD-MM-YYYY  HH:mm:SS')}.xlsx`);
            })
            .catch((thrown) => {
                callback();
                if (axios.isCancel(thrown)) {
                } else {
                    const error = thrown.response;
                    //TODO Something when error is thrown?
                }
            });
    } catch (error) {
        //TODO...shure.....
        callback();
    }
}

const copyAndStringify = (value, apiUrl) => {
    var sendObject = DeepCopy(value);

    if (apiUrl !== 'crmDealFront') {
        Object.keys(sendObject['filters']).forEach(function (key) {
            sendObject['filters'][key] = JSON.stringify(sendObject['filters'][key]);
        });
    } else {
        //for (let i = 0; i < value.length; i++) {
        //    Object.keys(sendObject[i].settings["filters"]).forEach(function (key) {
        //        sendObject[i].settings["filters"][key] = JSON.stringify(sendObject[i].settings["filters"][key]);
        //    });
        //}
    }

    return sendObject;
};

const copyAndDeserialize = (value, apiUrl) => {
    var returnObject = DeepCopy(value);

    if (apiUrl !== 'crmDealFront') {
        Object.keys(returnObject['filters']).forEach(function (key) {
            returnObject['filters'][key] = JSON.parse(returnObject['filters'][key]);
        });
    } else {
        //for (let i = 0; i < value.length; i++) {
        //    Object.keys(returnObject[i].settings["filters"]).forEach(function (key) {
        //        returnObject[i].settings["filters"][key] = JSON.parse(returnObject[i].settings["filters"][key]);
        //    });
        //}
    }

    return returnObject;
};
